// extracted by css-extract-rspack-plugin
export default {"cls1":"VerticalSpacer-cls1_8Aw","cls2":"VerticalSpacer-cls2_6Jz VerticalSpacer-cls1_8Aw"};